import ApnaCircleMarketplace from './components/ApnaCircleApp';

function App() {
  return <ApnaCircleMarketplace />;
}

export default App;
